import { ParsedDate } from '../parsed/parsedDate';
import z from 'zod';

export const CartGenerations = z.object({
    id: z.string().nullish(),
    isNew: z.boolean().nullish(),
    createdBy: z.string(),
    createdOn: ParsedDate.nullish(),
    hasRampWheels: z.boolean(),
    hasBrakeWheels: z.boolean(),
    modifiedBy: z.string(),
    modifiedOn: ParsedDate.nullish(),
    productNumber: z.string(),
    version: z.string(),
});

export type CartGenerations = z.infer<typeof CartGenerations>;
